import { createContext } from "react"

export const initialStateContext = {
    project: null,
    projectStartDate: null,
    projectEndDate: null,
}

export const ProjectStateContext = createContext(initialStateContext)